import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { BASE_API_URL } from "../../core/environment.tokens";
import { MessagingService } from "../../core/messaging/messaging.service";
import { SeverityType } from "../../core/messaging/severity-type.enum";
import { Textbox } from "../../dynamic-forms/inputs/textbox/textbox.model";
import { CopyChartService } from "../../platform/api/copy-chart/copy-chart.service";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { GridColumnDefinition } from "../grid/models/grid-column-definition.model";
import { GridConfiguration } from "../grid/models/grid-configuration.model";
import { GridFilter } from "../grid/models/grid-filter.model";
import { GridRequest } from "../grid/models/grid-request.model";


@Component({
    selector: "app-attach-chart-modal",
    templateUrl: "./attach-chart-modal.component.html",
    styleUrls: ["./attach-chart-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachChartModalComponent implements OnInit {
    @Input() chartData: any[] = [];
    @Output() onCancel = new EventEmitter();
    instructionMessage = "Select the desired chases for chase attachment and then click 'Copy Chart'. \nThese chases will move to data entry.";
    firstName = "";
    lastName = "";
    modalVisible = true;
    request: GridRequest;

    constructor(
        @Inject(BASE_API_URL) private readonly baseApiUrl: string,
        private readonly copyChartService: CopyChartService,
        private readonly messagingService: MessagingService,
        private changeDetector: ChangeDetectorRef
    ) { }

    attachChartGridConfiguration: GridConfiguration;
    attachChartChaseGridSelection: any = [];

    ngOnInit(): void {
        this.createGrid();
        this.firstName = StringHelper.toTitleCase(this.chartData[0]?.firstName) ?? "";
        this.lastName = StringHelper.toTitleCase(this.chartData[0]?.lastName) ?? "";
    }

    get enableCopyChartActions(): boolean {
        return this.attachChartChaseGridSelection.length > 0;
    }

    createGrid(): void {
        this.createCopyChartGridConfiguration();

        this.request = new GridRequest({
            url: `${this.baseApiUrl}chase/query-archive`,
            filters: [
                new GridFilter({
                    input: new Textbox(),
                    key: "MemberSourceAliasId",
                    value: this.chartData[0].memberId,
                    show: false,
                }),
                new GridFilter({
                    input: new Textbox(),
                    key: "DataSet",
                    value: "Unarchived",
                    show: false,
                }),
                new GridFilter({
                    input: new Textbox(),
                    key: "MemberWithCharts",
                    value: "0",
                    show: false,
                }),
            ],
        });

    }

    createCopyChartGridConfiguration(): void {
        this.attachChartGridConfiguration = new GridConfiguration({
            columns: this.getCopyChartGridColumns(),
            selectionMode: "multiple",
            showActionColumn: false,
            showExportAction: false,
            pageSize: 10,
            pageSizeOptions: [5, 10, 15, 20],
        });
    }

    private getCopyChartGridColumns(): GridColumnDefinition[] {
        const defaultColumns = [
            new GridColumnDefinition({
                field: "chaseId",
                header: "Chase ID",
                routeUrl: "/members/chase/:chaseId",
            }),
            new GridColumnDefinition({ field: "chaseSourceAliasId", header: "Customer Chase ID", isSortableColumn: false }),
            new GridColumnDefinition({ field: "projectName", header: "Project", isSortableColumn: false }),
            new GridColumnDefinition({ field: "measureCode", header: "Measure", isSortableColumn: false }),
            new GridColumnDefinition({ field: "serviceProviderName", header: "Provider Name", isSortableColumn: false }),
            new GridColumnDefinition({ field: "masterDocumentSourceId", header: "AID", isSortableColumn: false }),
            new GridColumnDefinition({ field: "documentSourceLocation", header: "Location", isSortableColumn: false }),

        ];

        return defaultColumns;
    }

    cancelAction(): void {
        this.modalVisible = false;
        this.onCancel.emit();
        this.changeDetector.markForCheck();
    }

    copyChart(): void {

        const payload: any[] = [];
        for (const chase of this.attachChartChaseGridSelection) {
            for (const chart of this.chartData) {
                payload.push({ targetChaseId: chase.chaseId, sourceChartId: chart.chartId });
            }
        }

        this.copyChartService.copyChartsToMultipleChasesNew(payload).subscribe(
            data => {
                this.messagingService.showToast("Chart copied Successfully.", SeverityType.SUCCESS);
                this.cancelAction();
                this.changeDetector.markForCheck();
            },
            error => {
                this.messagingService.showToast("Failed to copy", SeverityType.ERROR);
                this.changeDetector.markForCheck();
            }
        );
    }

}
